<template>
  <el-popover ref="popoverRef" placement="top-start" width="200" popper-class="popover-content" trigger="hover">
    <span
      slot="reference"
      class="tag-text-com theme-tag-content"
      :class="tagItem.fieldThemeName"
    >
      <div class="field-sort-num" v-if="tagSortShow && !isNaN(tagItem.fieldIndex)">
        <div class="theme-tag-content" :class="tagItem.fieldThemeName">{{ tagItem.fieldIndex + 1 }}</div>
      </div>
      <span :data-sign="sign">{{ text }}</span>
      <i v-if="couldClose" @click="closeHandle" class="iconfont iconcha icon"></i>
    </span>
    <div class="tip-content">
      <div>
        <span>标签：</span>
        <span class="blue">{{ tagItem.columnTitle || tagItem.title }}</span>
      </div>
      <div v-if="false && tagItem.columnFullName !== tagItem.columnTitle">
        <span>标签所属：</span>
        <span>{{ tagItem.columnFullName }}</span>
      </div>
      <div :style="{ textAlign: 'right', marginTop: '10px' }" v-if="false">
        <el-button size="mini" @click="$refs.popoverRef.doClose()">
          <span>关闭</span>
        </el-button>
        <el-button size="mini" type="danger" v-if="couldClose" @click="closeHandle">
          <span>删除</span>
        </el-button>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    text: {
      type: String,
      required: true
    },
    sign: {
      type: String,
      default: ''
    },
    tagItem: {
      type: Object,
      required: true
    },
    couldClose: {
      type: Boolean,
      default: false
    },
    tagSortShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeHandle() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../index.scss';
.tag-text-com {
  position: relative;
  background-color: rgba(red, 0.5);

  .field-sort-num {
    position: absolute;
    top: -12px;
    left: -14px;
    line-height: 18px;
    text-align: center;
    color: #2c3443;
    font-size: 12px;
    text-indent: 0;
    border-radius: 50%;
    background-color: #fff;
    user-select: none;

    .theme-tag-content {
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #fff;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .icon {
    text-indent: 0;
    font-size: 12px;
    margin: 0 6px;
    cursor: pointer;
  }
}
.popover-content {
  .tip-content {
    font-size: 14px;
    color: #3d465a;
    padding: 10px;
    line-height: 22px;

    .blue {
      color: #409eff;
    }
  }
}
</style>
